import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(0),
      // marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },

  buttons: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  headingMargin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
  },
}));
